import { useState, useEffect } from "react";
import { appendStyleSheet, getEndpoint, getUrl, setCmsSeoData, fetchAnchorValue } from '../../../common/utils.js';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SxProps, Theme } from '@mui/system';
import "./FaqList.css";
import bcrypt from 'bcryptjs-react';
FaqList.version = 1000;
FaqList.lang = 'en';
FaqList.langs = [
  'en'
];
FaqList.setLang = (lang: any) => {
  FaqList.lang = lang;
}

Object.defineProperty(FaqList, 'name', {
  writable: true,
  value: 'FaqList'
}); interface SeoSchema {
  '@context': string;
  '@type': string;
  mainEntity: {
    '@type': string;
    name: string;
    acceptedAnswer: {
      '@type': string;
      text: string;
    };
  }[];
}



export function FaqList(props: any) {

  const { anchorLinksValue } = props;

  const [seoPageData, setSeoPageData] = useState<any>({});
  const seoEndpoint = getEndpoint(props, "MAIN");
  useEffect(() => {
    if (!seoEndpoint || !seoEndpoint?.isSSR || !seoEndpoint?.SSRDataObj) {
      fetchComponentDataSEO();
    }
  }, [seoEndpoint]);


  const fetchComponentDataSEO = () => {
    let headerAPI_SEO = getUrl(props, 0, false, "MAIN", true)
    let headerString2 = '?' + headerAPI_SEO.split("?")[1];
    headerString2 = bcrypt.hashSync(headerString2, 6);
    const headers2 = { 'p-nonce': headerString2 };
    fetch(headerAPI_SEO, { headers: headers2 })
      .then(data => data.json())
      .then(parsedData => {
        setSeoPageData(parsedData.items[0]);
      })
      .catch(() => {
        //console.log("error")
      })
  }

  let styles = require("./FaqList.css");
  appendStyleSheet("FaqList", styles);

  if (seoEndpoint !== undefined && seoEndpoint && seoEndpoint.isSSR && seoEndpoint.SSRDataObj
    && seoPageData !== undefined && seoPageData && Object.keys(seoPageData).length === 0
    && seoEndpoint.SSRDataObj.items && seoEndpoint.SSRDataObj.items.length != 0) {
    setCmsSeoData(props, seoEndpoint.SSRDataObj.items[0], "ListView");
    setSeoPageData(seoEndpoint.SSRDataObj.items[0]);
  }

  const [expandedAccordion, setExpandedAccordion] = useState(0);
  const handleAccordionChange = (index: any) => {
    setExpandedAccordion(index);
  };

  // Define custom styles
  const accordionStyle: SxProps<Theme> = {
    backgroundColor: '#ECECEC',
    boxShadow: 'none',
    border: '1px solid #ddd',
  };

  const accordionSummaryStyle: SxProps<Theme> = {
    backgroundColor: '#ECECEC',
    borderBottom: '1px solid #ddd',
  };

  const accordionDetailsStyle: SxProps<Theme> = {
    backgroundColor: '#fff',
  };
  const renderFaqList = (seoSchema: SeoSchema | null): React.ReactNode => {
    if (!seoSchema || !seoSchema.mainEntity || seoSchema.mainEntity.length === 0) {
      return null;
    }
    
    return (
      <div className="ThemeThreeListAccoordianMainWrapper">
         <div className='ThemeThreeListViewHeadingWrap'>
            <a className='ThemeThreeListViewHeading' href={props.mainHeadingHref} target={fetchAnchorValue(anchorLinksValue, props.mainHeadingHref)} style={{ color: props.mainHeadingColor }}>
              {props.mainHeading}
            </a>
        </div>
        <div className="ThemeThreeListAccordianWrapper">
          {/* <p className="ThemeThreeHomeAccoordianTitle">{seoPageData && seoPageData?.syn}</p> */}
          {seoSchema.mainEntity.map((item, index) => (
            <Accordion key={index} style={{ marginBottom: '20px', overflow: 'hidden'}} sx={accordionStyle}  expanded={expandedAccordion === index}
            onChange={() => handleAccordionChange(index)} className="ThemeThreeListAccordianHeaderWrapper">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="ListAccordionExpandedIcon"/> }
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={accordionSummaryStyle}
                className="ThemeThreeListAccordianHeader"
                
              >
                <Typography className='FaqListQuestions'>{item.name}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={accordionDetailsStyle} className="ThemeThreeListAccordianDescriptionWrapper">
                <Typography  className="ThemeThreeListAccordianDescription"
                  dangerouslySetInnerHTML={{ __html: item.acceptedAnswer.text }}
                />
              </AccordionDetails>
            </Accordion>
          ))}
        </div></div>
    );
  };



  return (
    seoPageData && Object.keys(seoPageData).length > 0 && !(Array.isArray(seoPageData)) && seoPageData?.seoSchema && seoPageData?.seoSchema.length != 0 ? <div>{renderFaqList(JSON.parse(seoPageData?.seoSchema))}</div> : ''
  );
}
